// ════════════════════════════════════════════════════════════════════════════
// Beskar Jobs Widget — API Client
// ════════════════════════════════════════════════════════════════════════════

import type { EmbedConfig, ApplyResponse, VerifyStatus, ApplicationData } from './types';

const API_BASE = 'https://candidates-api-683030324250.us-central1.run.app';

export async function fetchConfig(orgSlug: string): Promise<EmbedConfig> {
  const res = await fetch(`${API_BASE}/embed/config/${encodeURIComponent(orgSlug)}`, {
    headers: { 'x-self-assess': '1' },
  });
  if (!res.ok) throw new Error(`Config fetch failed: ${res.status}`);
  return res.json();
}

export async function submitApplication(
  orgSlug: string,
  jobSlug: string,
  data: ApplicationData
): Promise<ApplyResponse> {
  const res = await fetch(`${API_BASE}/embed/apply/${encodeURIComponent(orgSlug)}/${encodeURIComponent(jobSlug)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-self-assess': '1' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Application failed' }));
    throw new Error(err.error || `Apply failed: ${res.status}`);
  }
  return res.json();
}

export async function checkStatus(candidateId: string, token: string): Promise<VerifyStatus> {
  const res = await fetch(`${API_BASE}/embed/status/${candidateId}?token=${encodeURIComponent(token)}`, {
    headers: { 'x-self-assess': '1' },
  });
  if (!res.ok) throw new Error(`Status check failed: ${res.status}`);
  return res.json();
}

export async function submitGapAnswers(
  candidateId: string,
  token: string,
  answers: Record<string, string>
): Promise<void> {
  const res = await fetch(`${API_BASE}/embed/answers/${candidateId}?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-self-assess': '1' },
    body: JSON.stringify({ answers }),
  });
  if (!res.ok) throw new Error(`Answer submission failed: ${res.status}`);
}
